import React from "react";

import OACLogoPic from "../2015-OAC-Logo-RGB.png";
import SpotlightLogoPic from "../spotlight.en.brand.strapline_Sec.png";
import PermanentMissionLogo from "../permanent-mission-canada-logo.png";
import Header from "./Header";
import LangSwitcher from "./LangSwitcher";

import { contact as str } from "$strings";

export default () => {
  return (
    <div>
      {/* <div className="media-query-viz"></div> */}
      <Header />
      <h1>{str.title}</h1>
      <div className="Contact-details">
        <div>
          <iframe
            src="https://player.vimeo.com/video/383210606"
            title={str.video_title}
            frameborder="0"
            allow="autoplay; fullscreen"
            allowFullScreen
          ></iframe>
        </div>
        <div className="Contact-info">
          {str.description.split("\n\n").map((t, i) => (
            <p key={i}>{t}</p>
          ))}
          <p>
            <b>{str.email_label}: </b>
            <a href="mailto:carey.anne.jernigan@gmail.com">
              {" "}
              carey.anne.jernigan@gmail.com
            </a>
          </p>
          <p>
            <b>{str.portfolio_label}: </b>
            <a href="https://www.careyjernigan.com"> www.careyjernigan.com</a>
          </p>
          <p>
            <b>{str.upcoming_exhibitions_label}:</b>
            <ul>
              {str.upcoming_exhibitions.map((exhibition, i) => (
                <li key={i} dangerouslySetInnerHTML={{ __html: exhibition }} />
              ))}
            </ul>
          </p>
          <p>
            <b>{str.website_credit_label}: </b>
            <a href="https://garitychapman.com"> Garity Chapman</a>
          </p>
        </div>
      </div>
      <div className="Contact-footer">
        <div className="acknowledgement">{str.acknowledgement}</div>
        <div className="funder-logos">
          <img
            id="CCA"
            alt=""
            src="https://canadacouncil.ca/-/media/Images/CCA/Design_Elements/LogosAndAwknowledgement/large-CCFA-logo-full-en.svg?h=111&la=en&w=598&hash=96143AC84EBCB7535BF8D8E28BCFAE91E1350402"
          />
          <img id="Spotlight" alt="" src={SpotlightLogoPic} />
          <br />
          <img id="OAC" alt="" src={OACLogoPic} />
          <img id="PermanentMission" alt="" src={PermanentMissionLogo} />
        </div>
      </div>
      <div className="lang-switcher">
        <LangSwitcher />
      </div>
    </div>
  );
};
